module.exports = __webpack_public_path__ + "static/img/homeleft1.431271f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft1.png
// module id = nsLv
// module chunks = 13